export default __webpack_public_path__ + "static/reporting-bae384ba2aca0ad086a460fa22afa8c4.png";